export default __webpack_public_path__ + "static/media/team.aebd8338.gif";